<template>
  <div class="col-12 connections">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Анализ надежности</h5>
      </div>
      <div class="card-body">
        <ul class="info-list d-md-flex col-md-9">
          <li class="d-flex flex-row col-md-3 col-12 align-items-center">
            <span class="info-title">Все факторы</span>
            <span class="info-value text-end">{{ totalFactors }}</span>
          </li>
          <li
            class="d-flex flex-row col-md-3 col-12 align-items-center ms-md-4"
          >
            <span class="info-value d-flex align-items-center">
              <div class="circle success me-3"></div>
              Положительные</span
            >
            <span class="text-end">{{ prosFactors?.length || 0 }}</span>
          </li>
          <li
            class="d-flex flex-row col-md-3 col-12 align-items-center ms-md-4"
          >
            <span class="info-value d-flex align-items-center">
              <div class="circle decline me-3"></div>
              Отрицательные</span
            >
            <span class="text-end">{{ consFactors?.length || 0 }}</span>
          </li>
        </ul>
        <div
          class="accordion mt-4"
          id="accordionOne"
          v-if="prosFactors?.length"
        >
          <div
            class="accordion-item px-2"
            v-for="(factor, index) in prosFactors"
            :key="index"
          >
            <h2 class="accordion-header" :id="'heading' + index">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapse' + index"
                aria-expanded="false"
                :aria-controls="'collapse' + index"
              >
                <div class="circle me-3" :class="factor.status"></div>
                {{ factor.title }} :
              </button>
            </h2>
            <div
              :id="'collapse' + index"
              class="accordion-collapse collapse"
              :aria-labelledby="'heading' + index"
              data-bs-parent="#accordionOne"
            >
              <div class="accordion-body">
                {{ factor.text }}
              </div>
            </div>
          </div>
        </div>
        <div v-else>Положительных факторов не обнаружено</div>

        <div
          class="accordion mt-4"
          id="accordionTwo"
          v-if="consFactors?.length"
        >
          <div
            class="accordion-item px-2"
            v-for="(factor, index) in consFactors"
            :key="index"
          >
            <h2 class="accordion-header" :id="'heading-two' + index">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapse-two' + index"
                aria-expanded="false"
                :aria-controls="'collapse-two' + index"
              >
                <div class="circle me-3" :class="factor.status"></div>
                {{ factor.title }} :
              </button>
            </h2>
            <div
              :id="'collapse-two' + index"
              class="accordion-collapse collapse"
              :aria-labelledby="'heading-two' + index"
              data-bs-parent="#accordionTwo"
            >
              <div class="accordion-body">
                {{ factor.text }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="mt-2">Нарушений не обнаружено</div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, computed, watchEffect } from "vue";

export default defineComponent({
  name: "Analyze",
  props: {
    company: Object,
  },
  setup(props) {
    const prosFactors = ref([]);
    const consFactors = ref([]);

    const totalFactors = computed(
      () => (prosFactors.value?.length || 0) + (consFactors.value?.length || 0)
    );

    function parseFactorsFromList(doc, listId, status) {
      const root = doc.getElementById(listId);
      if (!root) return [];

      const items = Array.from(root.querySelectorAll(":scope > li"));

      return items
        .map((li, idx) => {
          // В твоём HTML внутри li два div подряд
          const divs = li.querySelectorAll(":scope > div");

          const title = (divs?.[0]?.textContent || "").trim();
          const text = (divs?.[1]?.textContent || "").trim();

          // если разметка неожиданно другая — не добавляем пустышки
          if (!title && !text) return null;

          return {
            id: idx + 1,
            title,
            text,
            status, // "success" или "decline"
          };
        })
        .filter(Boolean);
    }

    function parseCompanyHtml(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const rating = doc.getElementById("rating");
      if (!rating) {
        prosFactors.value = [];
        consFactors.value = [];
        return;
      }

      // Берём только факторы из tab-content
      prosFactors.value = parseFactorsFromList(doc, "cr1", "success");
      consFactors.value = parseFactorsFromList(doc, "cr3", "decline");
    }

    watchEffect(() => {
      const html = props.company?.html_checko;
      if (html) parseCompanyHtml(html);
      else {
        prosFactors.value = [];
        consFactors.value = [];
      }
    });

    return {
      prosFactors,
      consFactors,
      totalFactors,
    };
  },
});
</script>
